import { meta } from '@/helpers/constants/router';
export default [
    {
        path: 'billing',
        component: () => import('@/views/Wrapper.vue'),
        meta: { ...meta, title: 'Billing' },
        children: [
            {
                path: 'billing-manager',
                component: () => import('@/views/Wrapper.vue'),
                meta: {
                    title: 'Billing Manager',
                    subtitle: 'View all your Billings here.',
                    redirect: 'billing',
                },
                children: [
                    {
                        path: '/',
                        name: 'billing',
                        component: () => import('@/views/v2/Billing.vue'),
                        meta: {
                            title: 'Billing',
                            subtitle: 'View all your convenience fees here.',
                        },
                    },
                    {
                        path: 'plans',
                        name: 'enterprise-plans',
                        component: () => import('@/views/v2/EnterprisePlans.vue'),
                        meta: { ...meta, title: 'Subscription Plans' },
                    },
                    {
                        path: ':uuid',
                        name: 'billing-details',
                        props: true,
                        component: () => import('@/views/v2/BillingDetails.vue'),
                        meta: { ...meta, title: 'View Billing' },
                    },
                ],
            },
            {
                path: 'payment-preferences',
                component: () => import('@/views/v2/PaymentPreferencesTabs.vue'),
                meta: {
                    title: 'Payment Preferences Manager',
                    subtitle: 'View all Payment Preferences here.',
                    redirect: 'billing',
                },
                children: [
                    {
                        path: '/',
                        name: 'payment-preferences',
                        component: () => import('@/views/v2/PaymentPreferences.vue'),
                        meta: {
                            title: 'Payment Preferences',
                            subtitle: 'View Your Default Payment Details here.',
                        },
                    },
                    {
                        path: 'saved-payment-methods',
                        name: 'saved-payment-methods',
                        component: () => import('@/views/v2/SavedPaymentMethods.vue'),
                        meta: {
                            ...meta,
                            title: 'Saved Payment Methods',
                            subtitle: 'View all Payment Preferences here.',
                        },
                    },
                    {
                        path: 'create',
                        name: 'add-payment-method',
                        props: true,
                        component: () => import('@/views/v2/PaymentPreferencesCreate.vue'),
                        meta: { ...meta, title: 'Add Payment Methods' },
                    },
                    {
                        path: ':uuid/:from/edit',
                        name: 'edit-payment-method',
                        props: true,
                        component: () => import('@/views/v2/PaymentPreferencesEdit.vue'),
                        meta: { ...meta, title: 'Edit Payment Method' },
                    },
                ],
            },
        ],
    },
    {
        path: 'enterprise-plan',
        component: () => import('@/views/Wrapper.vue'),
        meta,
        redirect: { name: 'enterprise-plan-msme' },
        children: [
            {
                path: 'msme-extend',
                name: 'enterprise-plan-msme',
                component: () => import('@/views/v2/MsmeExtended.vue'),
            },
        ],
    },
];
